import { isEmpty } from "lodash";
import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import cx from "classnames";
import styles from "./NavbarV3.module.scss";
import { V3BrandLockup } from "./V3BrandLockup";
import { loginRequest } from "features/authConfig";
import { useCurrentPatient } from "features/patientDashboard/hooks/useCurrentPatient";
/*
  uncomment this line to import the medLogo image if needed.
  import medLogo from "images/new_med_logo.svg";
*/
import medLogo from "images/med_logo_twenty_five_years.svg";
import { Office } from "types/office";
import { selectSessionOffice } from "features/patientDashboard/patientDashboardSlice";

export interface NavbarProps {
  children?: React.ReactNode;
  className?: string;
  below?: React.ReactNode;
  primaryLink?: React.ReactNode;
  office?: Office;
  showLogout?: boolean;
}

export const Navbar: React.FC<NavbarProps> = ({
  children,
  primaryLink,
  office,
  below,
  className,
  showLogout,
}) => {
  const { handleLogoutRedirect } = useCurrentPatient();
  const sessionOffice = useSelector(selectSessionOffice);
  const location = useLocation();
  const brandingOffice = office || sessionOffice;
  const cobrandedLogoUrl = brandingOffice?.cobrandedLogoUrl;
  const vintageName = brandingOffice?.vintageName;
  const imgUrl = cobrandedLogoUrl || medLogo;
  const showV3SchedulerLockup =
    /^\/appointments\/[^/]+(?:\/.*)?$/.test(location.pathname) &&
    !!(cobrandedLogoUrl || vintageName);

  const { instance, inProgress } = useMsal();
  let activeAccount;

  if (instance) {
    activeAccount = instance.getActiveAccount();
  }

  const handleResponse = (response) => {
    /**
     * To see the full list of response object properties, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
     */
    /*
    if (response !== null) {
      accountId = response.account.homeAccountId;
      username = response.account.username;
      welcomeUser(username);
      updateTable(response.idTokenClaims);
    } else {
      selectAccount();
    }*/
  };

  const handleLoginRedirect = () => {
    instance
      .loginRedirect(loginRequest)
      .then(handleResponse)
      .catch((error) => console.log(error));
  };

  return (
    <nav>
      <div className={cx(className, styles.bar)}>
        <div
          className={cx(styles.logoContainer, {
            [styles.cobranded]: !!cobrandedLogoUrl || showV3SchedulerLockup,
          })}
        >
          {primaryLink ? (
            primaryLink
          ) : showV3SchedulerLockup ? (
            <V3BrandLockup
              cobrandedLogoUrl={cobrandedLogoUrl}
              vintageName={vintageName}
            />
          ) : (
            <a href="https://www.myeyedr.com/">
              <img src={imgUrl} className={styles.logo} alt="MED Logo" />
            </a>
          )}
        </div>
        {children}
        {showLogout && <div className={styles.logout} onClick={handleLogoutRedirect}><u>&lt; LOGOUT</u></div>}
      </div>
      {below && <div className={styles.below}>{below}</div>}
    </nav>
  );
};
